// extracted by mini-css-extract-plugin
module.exports = {"outer":"_3dGgt","headerWrap":"_3n9UD","heading":"_3Vnh_","contentWrap":"_2BBGp","content":"_2Vbj4"};